/* eslint-disable no-useless-computed-key */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { IconButton, Tooltip, Box, Typography, Button, TextField, Switch, CircularProgress, LinearProgress, Collapse } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { colors, fonts } from '../../../utils';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
import { successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment';
import { setAllPodcasts } from '../../../redux/slices/shareholderEducation/shareholderEducation';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import ReadMoreReact from 'read-more-react/dist/components/ReadMoreReact';
import FilledSelectOption from '../../../components/input/FilledSelectOption';


const Podcasts = () => {
	const dispatch = useDispatch();
	const { userId, fullName } = useSelector((state) => state?.activeAccount);

	const { colorWhite, colorGreenGradient } = colors;

	const { podcasts } = useSelector((state) => state.shareHolderEducation);
	const [openModal, setOpenModal] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isEditing, setIsEditing] = useState(false);
	const [isLoadingImg, setIsLoadingImg] = useState(false);
	const [isLoadingModal, setIsLoadingModal] = useState(false);

	const [formData, setFormData] = useState({
		title: '',
		description: '',
		url: '',
		image: '',
	});

	const [currentParams, setCurrentParams] = useState({
		limit: 10,
		page: 1,
		totalPages: 0,
		totalRecords: 0,
	});

	const [filters, setFilters] = useState({
		search: '',
		status: '',
		date_from: null,
		date_to: null,
	});
	const [filtersOpen, setFiltersOpen] = useState(false);

	const handleFilterChange = (e) => {
		setFilters((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const handleFilterDateChange = (name, value) => {
		setFilters((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handleApplyFilters = () => {
		getData(currentParams.limit, 1, filters);
	};

	const handleClearFilters = () => {
		const clearedFilters = {
			search: '',
			status: '',
			date_from: null,
			date_to: null,
		};
		setFilters(clearedFilters);
		getData(currentParams.limit, 1, clearedFilters);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		setIsEditing(false);
	};

	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};

	const getData = async (limit, page, filterParams = filters) => {
		setIsLoading(true);
		try {
			await Api.post(endPoints?.shareHolderEducation?.fetchPodcast, {
				type: "podcast",
				status: filterParams.status || "all",
				limit: limit || 10,
				page: page || 1,
				search: filterParams.search || null,
				date_from: filterParams.date_from ? dayjs(filterParams.date_from).format('YYYY-MM-DD') : null,
				date_to: filterParams.date_to ? dayjs(filterParams.date_to).format('YYYY-MM-DD') : null,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					dispatch(
						setAllPodcasts(
							response?.data?.data?.shareholderss?.data?.map((d, index) => ({
								index: index + 1,
								id: d?.id,
								creator_name: d?.creator_name,
								title: d?.title,
								description: d?.description,
								url: d?.url,
								dt: d?.dt,
								is_enabled: d?.is_enabled,
								image: d?.image,
							})),
						),
					);
					const { page, limit, totalPages, totalRecords } = response?.data?.data?.shareholderss;
					setCurrentParams({ page, limit, totalPages, totalRecords });
					setIsLoading(false);
				})
				.catch((error) => {
					setIsLoading(false);
				});
		} catch (err) {
			setIsLoading(false);
		}
	};

	const handleCreateModal = () => {
		setFormData({ title: '', description: '', url: '', image: '' });
		setOpenModal(true);
		setIsEditing(false);
	};

	const handleEditModal = (val) => {
		setFormData({
			title: val.title,
			description: val.description,
			url: val.url,
			is_enabled: val.is_enabled,
			id: val.id,
			image: val.image
		});
		setOpenModal(true);
		setIsEditing(true);
	};

	const handleSubmit = async () => {
		setIsLoadingModal(true);

		if (!isEditing) {
			try {
				await Api.post(endPoints?.shareHolderEducation?.createPodcast, {
					...formData,
					type: "podcast",
					creator_id: userId,
					creator_name: fullName,
					is_enabled: true,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("Podcast Created Successfully");
						setIsLoadingModal(false);
					})
					.catch((error) => {
						setIsLoadingModal(false);
					});
			} catch (err) {
				setIsLoadingModal(false);
			}
		} else {
			try {
				await Api.post(endPoints?.shareHolderEducation?.updatePodcast, {
					...formData,
					type: "podcast",
					creator_id: userId,
					creator_name: fullName,
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getData();
						successNotify("Podcast Updated Successfully");
						setIsLoadingModal(false);
					})
					.catch((error) => {
						setIsLoadingModal(false);
					});
			} catch (err) {
				setIsLoadingModal(false);
			}
		}
	};

	useEffect(() => {
		getData();
	}, []);

	const handleSwitchClick = (event) => {
		event.stopPropagation();
	};

	const handleChangeTableSwitch = async (event, val) => {
		try {
			await Api.post(endPoints?.shareHolderEducation?.deletePodcast, {
				id: val.id,
				status: event.target.checked,
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					successNotify("Podcast Status Updated Successfully");
					getData();
				})
				.catch((error) => {
				});
		} catch (err) {
		}
	};

	const handleImageUpload = (event) => {
		setIsLoadingImg(true);
		if (event.target.files.length > 0) {
			let formDataUpload = new FormData();
			let file = event.target.files[0];
			let fileName = file.name.replace(/\s/g, '');
			let timestampedFileName = `${new Date().getTime()}_${fileName}`;

			formDataUpload.append('file', file, timestampedFileName);
			Api.post(endPoints?.file?.upload, formDataUpload, {
				headers: {
					'Content-Type': 'multipart/form-data',
					'xt-user-token': null
				}
			})
				.then((response) => {
					setIsLoadingImg(false);
					setFormData((prevState) => ({
						...prevState,
						image: response.data.data.link,
					}));
					successNotify("Banner Uploaded Successfully");
				})
				.catch((error) => {
					setIsLoadingImg(false);
				});
		}
	};

	const column = [
		{
			title: 'Id',
			field: 'id',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.id}</h4>,
		},
		{
			title: 'Title',
			field: 'title',
			width: "15%",
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.title?.length > 20 ?
					<ReadMoreReact
						text={rowData?.title}
						min={10}
						ideal={20}
						max={rowData?.title?.length}
						readMoreText="Read More"
					/> : rowData?.title}</h4>,
		},
		{
			title: 'Description',
			field: 'description',
			width: "20%",
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.description?.length > 25 ?
					<ReadMoreReact
						text={rowData?.description}
						min={10}
						ideal={25}
						max={rowData?.description?.length}
						readMoreText="Read More"
					/> : rowData?.description}</h4>,
		},
		{
			title: 'Banner',
			field: 'image',
			render: (rowData) => rowData?.image ? <img src={rowData?.image} height='60' width='80' style={{ objectFit: 'cover', borderRadius: '4px' }} alt="banner" /> : '-',
		},
		{
			title: 'YouTube URL',
			field: 'url',
			render: (rowData) => <h4 className='font-face-R'>{
				rowData?.url ?
					<a href={rowData?.url} target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2' }}>
						View
					</a> : '-'
			}</h4>,
		},
		{
			title: 'Creator',
			field: 'creator_name',
			render: (rowData) => <h4 className='font-face-R'>{rowData?.creator_name}</h4>,
		},
		{
			title: 'Date',
			field: 'dt',
			render: (rowData) => <h4 className='font-face-R'>{moment(rowData?.dt).format("DD-MM-YYYY")}</h4>,
		},
		{
			title: 'Edit',
			field: 'edit',
			filtering: false,
			render: (rowData) => (
				<Tooltip title='Edit'>
					<IconButton onClick={() => handleEditModal(rowData)} aria-label='Edit'>
						<EditIcon />
					</IconButton>
				</Tooltip>
			),
		},
		{
			title: 'Status',
			field: 'is_enabled',
			render: (rowData) =>
				<Switch onClick={handleSwitchClick} onChange={(event) => handleChangeTableSwitch(event, rowData)} checked={rowData?.is_enabled} name='enabled' />,
		},
	];

	return (
		<>
			<Card margin='3rem 1.5rem' padding='3rem'>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<ButtonCom onClickHandler={handleCreateModal} btnTitle={"Create"} />
				</Flex>

				{/* Filters Section */}
				<Box sx={{ mb: 3, backgroundColor: '#f5f5f5', borderRadius: '8px', overflow: 'hidden' }}>
					<Box
						sx={{
							p: 2,
							cursor: 'pointer',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							'&:hover': { backgroundColor: '#ebebeb' },
							transition: 'background-color 0.2s ease'
						}}
						onClick={() => setFiltersOpen(!filtersOpen)}
					>
						<Flex ai='center' gap='0.5rem'>
							<FilterListIcon sx={{ color: '#666' }} />
							<Typography variant='h6' sx={{ fontSize: '1.6rem', fontWeight: 600, color: '#333' }}>
								Filter Podcasts
							</Typography>
						</Flex>
						{filtersOpen ? <ExpandLessIcon sx={{ color: '#666' }} /> : <ExpandMoreIcon sx={{ color: '#666' }} />}
					</Box>

					<Collapse in={filtersOpen} timeout={300}>
						<Box sx={{ p: 2, pt: 1 }}>
							{/* Search Bar */}
							<Box sx={{ mb: 2 }}>
								<InputControl
									state={filters.search}
									onChange={handleFilterChange}
									label='Search by Title'
									name='search'
								/>
							</Box>

							{/* Dropdown Filters */}
							<Grid gtc='repeat(auto-fit, minmax(18rem, 1fr))' gap='1.5rem'>
								<FilledSelectOption
									label='Status'
									state={filters.status}
									onChange={handleFilterChange}
									options={[
										{ id: 'true', description: 'Active' },
										{ id: 'false', description: 'Inactive' },
									]}
									maxWidth='100%'
									minWidth='100%'
									width='100%'
									name='status'
								/>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date From'
										value={filters.date_from}
										onChange={(value) => handleFilterDateChange('date_from', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<DesktopDatePicker
										label='Date To'
										value={filters.date_to}
										onChange={(value) => handleFilterDateChange('date_to', value)}
										renderInput={(params) => <TextField {...params} size='small' />}
									/>
								</LocalizationProvider>
							</Grid>

							<Flex jc='space-between' ai='center' gap='1rem' mt='1.5rem'>
								<Button
									variant='text'
									startIcon={<ClearIcon />}
									onClick={handleClearFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', color: '#666' }}>
									Clear All
								</Button>
								<Button
									variant='contained'
									color='success'
									startIcon={<SearchIcon />}
									onClick={handleApplyFilters}
									sx={{ fontSize: '1.2rem', textTransform: 'none', px: 3 }}>
									Apply Filters
								</Button>
							</Flex>
						</Box>
					</Collapse>
				</Box>

				<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>
					<TransitionsModal
						open={openModal}
						handleClose={handleCloseModal}
						modalTitle={isEditing ? "Edit Podcast" : "Create Podcast"}
						isLoading={isLoadingModal}
					>
						<Grid gtc='repeat(auto-fit, minmax(40rem, 1fr))' padding='2rem'>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.title}
									onChange={handleChange}
									label='Title'
									name='title'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.description}
									onChange={handleChange}
									label='Description'
									name='description'
								/>
							</MarginHandler>
							<MarginHandler width='100%'>
								<InputControl
									state={formData?.url}
									onChange={handleChange}
									label='YouTube URL'
									name='url'
								/>
							</MarginHandler>
							{isLoadingImg ?
								<CircularProgress sx={{ margin: "auto" }} color="success" />
								:
								<>
									<input
										accept=".jpeg, .jpg, .png"
										style={{ display: 'none' }}
										id="banner-upload"
										type="file"
										onChange={(event) => handleImageUpload(event)}
									/>
									<label htmlFor="banner-upload">
										<Button
											variant="contained"
											component="span"
											fullWidth
											color='success'
											style={{ fontSize: '1em' }}
										>
											Upload Banner
										</Button>
									</label>
									{formData?.image &&
										<img height={100} style={{ margin: "auto", objectFit: 'cover', borderRadius: '4px' }} src={formData?.image} alt="banner preview" />
									}
								</>
							}

							<MarginHandler mt="2rem">
								<Button
									color='primary'
									variant='contained'
									onClick={handleSubmit}
									style={{
										background: colorGreenGradient,
										fontSize: '1.6rem',
										textTransform: 'none',
										padding: '0.7rem 2rem',
										color: colorWhite,
										borderRadius: '0.5rem',
										float: "right"
									}}
									disabled={!formData.title}
									className='font-face-R'>
									{isEditing ? "Update" : "Create"}
								</Button>
							</MarginHandler>
						</Grid>
					</TransitionsModal>
				</Flex>

				{isLoading ?
					<Box sx={{ m: '5rem' }}>
						<LinearProgress color="success" />
					</Box>
					:
					<Table
						columns={column}
						tableData={podcasts?.map((item) => ({ ...item }))}
						sorting
						columnsButton
						padding="3rem"
						showTitle
						paginationType='normal'
						titleHeading="Podcasts"
						showToolbar={true}
						pageSize={currentParams.limit}
						onChangeRowsPerPage={(event) => getData(parseInt(event.target.value, 10), 1)}
						totalRecords={currentParams.totalRecords}
						handlePageChange={(event, newPage) => getData(currentParams.limit, newPage + 1)}
						curPage={currentParams.page - 1}
					/>
				}
			</Card>
		</>
	);
};

export default Podcasts;
